import { connect } from 'react-redux'

import Session from '../../../../pages/settings/sessions/detailsSession'
import {
  fetchSessionsParticipants,
  removeError as removeErrorSessions,
  fetchSessionDetails,
} from '../../../../redux/sessions/actions'
import {
  getErrorMessage as getSessionsErrorMessage,
  getIsErrorFetchParticipant,
  getIsErrorFetchDetails,
} from '../../../../redux/sessions/selectors'
import {
  getIsErrorFetchFileById,
  getErrorMessage as getFormationsErrorMessage,
} from '../../../../redux/formations/selectors'
import {
  fetchFilesById,
  removeError as removeErrorFormations,
} from '../../../../redux/formations/actions'

const mapStateToProps = (state) => ({
  errorMessage: getSessionsErrorMessage(state) || getFormationsErrorMessage(state),
  isErrorFetchDetails: getIsErrorFetchDetails(state),
  isErrorFetchParticipant: getIsErrorFetchParticipant(state),
  isErrorFetchFileById: getIsErrorFetchFileById(state),
})

const mapDisptachToProps = (dispatch) => ({
  fetchSessionsParticipants: (id) => dispatch(fetchSessionsParticipants(id)),
  fetchSessionDetails: (id) => dispatch(fetchSessionDetails(id)),
  fetchFiles: (id) => {
    dispatch(fetchFilesById(id, 'sessions'))
  },
  removeError: () => {
    dispatch(removeErrorSessions())
    dispatch(removeErrorFormations())
  },
})

export default connect(mapStateToProps, mapDisptachToProps)(Session)
